import { LoadingIndicator } from "../../../assets/vfx";
import Drawer from "../../../assets/vfx/drawer/drawer";
import { RoleDto } from "../../../services/dto";
import DisplayData from "../../common/DisplayData/DisplayData";

interface RoleViewProps {
  data: RoleDto | undefined;
  show: boolean;
  onHide: () => void;
  onEdit: () => void;
}

export const RoleView = (props: RoleViewProps) => {
  return (
    <Drawer.View
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      onEdit={props.onEdit}
      title="View Role"
    >
      {!props.data ? (
        <LoadingIndicator isFullPage />
      ) : (
        <>
          <DisplayData text="Name" importedData={props.data?.name} />
          <DisplayData text="Display" importedData={props.data?.display} />
        </>
      )}
    </Drawer.View>
  );
};
